import { Component, OnInit, OnDestroy } from '@angular/core';
import { faEye, faDownload } from '@fortawesome/free-solid-svg-icons';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { MessageService } from 'src/app/share/sharedsubject';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-service-list',
    templateUrl: './service-list.component.html',
    styleUrls: ['./service-list.component.scss'],
    standalone: false
})

export class ServiceListComponent implements OnInit, OnDestroy {
  protected readonly faEye = faEye; 
  protected readonly faDownload = faDownload;
  stockServiceData: any[] = [];
  formattedDate: any;
  filterPayMode:string = "";
  payMode: string= "";
  companyData: any[];
  company: string = "";
  loader : boolean = false;
  errorMessage : any;
  isToster: boolean = false;
  message: any;
  subscription: Subscription;
  endOfResults: boolean = false;
  filters: any ={
  page: 0,
  }

  constructor(
    private readonly stockService: StockService,
    private readonly messageService: MessageService
  )
  {
    this.subscription = this.messageService.getMessage().subscribe((message: any) => {
      if (message) {
        this.isToster = true;
        this.message = message.text;
      }
    });
  }

  ngOnInit(){
    this.getAllServiceList();
  }


  getAllServiceList(){
    this.loader = true;
    let params : any = {
      page: this.filters.page
    }
    if(this.filterPayMode){
      params.filterPayMode = this.filterPayMode;
    }
    this.stockService.getAllServicetList(params).subscribe({
      next: (res:any) => {
      this.loader = false;
      if (res?.data.length) {
        this.stockServiceData = [...this.stockServiceData, ...res.data];
      } else {
        this.endOfResults = true;
      }
    },
      error: (error) => {
      this.errorMessage = error?.error?.error?.message;
      this.loader = false;
    }
    });
  }

  creditFilterList(payMode:any){ 
    this.filters.page = 0;
    this.endOfResults = false;
    this.stockServiceData = [];
    if(payMode){
      this.filterPayMode=payMode;
    }else{
      this.filterPayMode="";
    }
    this.getAllServiceList();
  }

  closeToster(event: any){
    this.isToster = false;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  loadMore() {
    if(this.endOfResults || this.loader) return;
    this.filters.page++;
    this.getAllServiceList();
  }
}
